import React, { useState, useEffect } from "react";
// import { Suspense, lazy } from "react";
import { callApi } from "./API";
import Routes from "./Router/index";

function App() {
  const [loading ,setLoading] =useState(false)
  
  function getHeader() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "getHeaderForBusiness",
    })
      .then((response) => response.html) // Assuming the API returns HTML as plain text
      .then((data) => {
        setLoading(true)
        setHtmlContent(data);
      });
  }
  const [htmlContent, setHtmlContent] = useState("");
  const [htmlContentFooter, setHtmlContentFooter] = useState("");

  function getFooter() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "footerTpl",
    })
      .then((response) => response.html) // Assuming the API returns HTML as plain text
      .then((data) => {
        setHtmlContentFooter(data);
      });
  }
  useEffect(() => {
    getHeader();
    getFooter()
  }, []);
  // getHeader();
  return (
    <>
    {loading && <>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      <div className="react-style min-height-page">
        <Routes />
      </div>
      <div dangerouslySetInnerHTML={{ __html: htmlContentFooter }} /> 
      </>
      }
    </>
  );
}

export default App;
